import { Button } from '@mantine/core';
import RefreshIcon from '../../../../../assets/icons/refresh.svg?react';
import Checkbox from '../../../../../components/Checkbox';
import reportStore from '../../store';
import { REPORT_NAMINGS, REPORT_TYPES } from '../../../../../consts/reportTypes';
import classNames from 'classnames';

const TableHeader = ({
  prevCount,
  currentCount,
  prevYear,
  prevPeriod,
  currentYear,
  currentPeriod,
  hasChanges,
  isResetting,
  isExpandAll,
  onReset,
  toggleExpandAll,
  reportType,
  // Initial-setup periods (no previous_period_id) have no mapped sheets to
  // expand under each file — hide the "Expand all" toggle entirely.
  isInitialSetup = false
}) => {
  const { isLockedPeriod } = reportStore;
  const isCustomReportType = reportType === REPORT_TYPES.CUSTOM;

  return (
    <div
      className={classNames('header', {
        'custom-report-type': isCustomReportType
      })}
    >
      {!isCustomReportType && (
        <div className="header-element border-right">
          <div className="title">
            <p>#</p>
          </div>
        </div>
      )}

      <div className="header-element">
        <div className="title">
          <p>Previous Period:</p>
          <p>
            {prevPeriod || 'N/A'} | Year: {prevYear || 'N/A'}
          </p>
        </div>
        {!isCustomReportType && (
          <p className="aif-amount">{prevPeriod ? `${prevCount} AIFs` : ''}</p>
        )}
      </div>
      <div className="header-element">
        <div className="title">
          <p>Current Period:</p>
          <p>
            {currentPeriod || 'N/A'} | Year: {currentYear || 'N/A'}
          </p>
        </div>
        <div className="actions">
          {!isLockedPeriod && (
            <Button
              size="sm"
              variant="none"
              disabled={!hasChanges || isResetting}
              leftSection={<RefreshIcon className={isResetting && 'custom-spinner'} />}
              bg="transparent"
              onClick={onReset}
              opacity={(!hasChanges || isResetting) && 0.5}
            >
              Reset
            </Button>
          )}

          {!isInitialSetup && (
            <button className="checkbox" onClick={toggleExpandAll}>
              <Checkbox label="Expand all" checked={isExpandAll} onChange={toggleExpandAll} />
              <span>Expand all</span>
            </button>
          )}

          {!isCustomReportType && (
            <p className="aif-amount">
              {currentCount} {REPORT_NAMINGS.FUND?.[reportType]}s
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default TableHeader;
